import { render, staticRenderFns } from "./TextPreview.vue?vue&type=template&id=5c0323bd&scoped=true"
import script from "./TextPreview.vue?vue&type=script&lang=js"
export * from "./TextPreview.vue?vue&type=script&lang=js"
import style0 from "./TextPreview.vue?vue&type=style&index=0&id=5c0323bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0323bd",
  null
  
)

export default component.exports